/**
 * @module map
 * @category utils
 */

import Debug from "debug";

const debug = Debug("map");

/**
 * Check to test if map is empty -- will return null if it isn't a map
 * @example isEmptyMap(new Map()); // returns true
 * @example isEmptyMap(new Map([["foo", "bar"]])); // returns false
 */
export const isEmptyMap = <K, V>(map: Map<K, V>) => {
  return !isNotEmptyMap(map);
};

/**
 * Check to test
 */
export const isNotEmptyMap = <K, V>(map: Map<K, V>): map is Map<K, V> => {
  if (map && map.constructor === Map) {
    return map.size > 0;
  }

  if (process.env["NODE_ENV"] !== "production") {
    // eslint-disable-next-line
    debug(
      `[isNotEmptyMap]: The map being verified is not a map: ${map}\n` +
        new Error().stack,
    );
  }

  return false;
};
